'use client';

import { usePreviousPage } from '../../../lib/hooks/use-previous-page';
import { BreadcrumbShared } from '../../ui/breadcrumb';

export function ProductDetailsBreadcrumbs({
  productTitle,
}: {
  productTitle: string;
}) {
  const previousPage = usePreviousPage();
  const previousPageIsCollection = previousPage.isFromCollection;

  return (
    <BreadcrumbShared>
      <BreadcrumbShared.List className="text-[hsl(var(--color))]/80">
        <BreadcrumbShared.Item>
          <BreadcrumbShared.Link
            href="/"
            className="hf:text-[hsl(var(--color))] transition-colors"
          >
            Home
          </BreadcrumbShared.Link>
        </BreadcrumbShared.Item>
        {previousPageIsCollection && (
          <>
            <BreadcrumbShared.Separator className="text-[hsl(var(--color))]" />
            <BreadcrumbShared.Item>
              <BreadcrumbShared.Link
                href={previousPage.collection ?? '/'}
                className="hf:text-[hsl(var(--color))] transition-colors"
              >
                {previousPage.collectionTitle}
              </BreadcrumbShared.Link>
            </BreadcrumbShared.Item>
          </>
        )}
        <BreadcrumbShared.Separator className="text-[hsl(var(--color))]" />
        <BreadcrumbShared.Item>
          {productTitle && (
            <BreadcrumbShared.Page className="text-[hsl(var(--color))]">
              {productTitle}
            </BreadcrumbShared.Page>
          )}
        </BreadcrumbShared.Item>
      </BreadcrumbShared.List>
    </BreadcrumbShared>
  );
}
